var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { styleBlock } from "../styleBlock";
const InputSearch = (_a) => {
    var { className, transparent, translateFunc } = _a, inputProps = __rest(_a, ["className", "transparent", "translateFunc"]);
    const b = styleBlock("search");
    const [value, setValue] = useState(inputProps.value || "");
    function handleChange(e) {
        setValue(e.target.value);
        if (inputProps.onChange) {
            inputProps.onChange(e);
        }
    }
    function clearValue(e) {
        e.target.value = "";
        handleChange(e);
    }
    const { size } = inputProps;
    const crossTopMargin = size === "sm" ? "mt-0" : size === undefined ? "mt-1" : "mt-2";
    return (React.createElement("div", { className: b.toString() + " position-relative " + className },
        React.createElement(Form.Control, Object.assign({ type: "text", className: "with-icon icon-search " + (transparent ? "transparent-background" : "") }, inputProps, { value: value, onChange: handleChange })),
        value && (React.createElement("div", { className: crossTopMargin + " input-inner-element visible" },
            React.createElement("button", { onClick: clearValue, type: "button", className: "d-block border-0 p-0 m-0", "aria-label": translateFunc("clear") })))));
};
export default InputSearch;
//# sourceMappingURL=index.js.map